// components/AppLayout.tsx
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from '@/components/layout/Navigation/TopNav';
import { RELEASE_TAG, VersionWelcomeModal } from '@/components/common/modal/VersionWelcomeModal';
import { useAcknowledgements } from '@/hooks/useAcknowledgements';
import { Box, CircularProgress } from '@mui/material';

export function AppLayout() {
    const { loaded, hasAcknowledged, acknowledge } = useAcknowledgements();

    const showVersionModal = loaded && !hasAcknowledged('version_release', RELEASE_TAG);

    const handleDismissVersion = async () => {
        await acknowledge('version_release', RELEASE_TAG);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
            <TopNav />
            <main style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                <Suspense
                    fallback={
                        <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100%' }}>
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Outlet />
                </Suspense>
            </main>
            <VersionWelcomeModal open={showVersionModal} onDismiss={handleDismissVersion} />
        </div>
    );
}
